export default __webpack_public_path__ + "static/media/prm-club-phone.cddfe005.png";